import React, { useState } from 'react';
import { PhaseSubTabs } from '../../campaign-detail/components/parts/PhaseSubTabs';
import { PageHeader } from './PageHeader';

export interface SettingsTabConfig {
  key: string;
  label: string;
  content: React.ReactNode;
}

export interface SettingsPageProps {
  subtitle?: string;
  tabs: SettingsTabConfig[];
  /** Tab a deep link opens. While it is absent from `tabs` (e.g. a tab that
   *  appears once a capability probe resolves) the first tab shows. */
  initialTab?: string;
}

export function SettingsPage({ subtitle, tabs, initialTab }: SettingsPageProps) {
  const [selected, setSelected] = useState(
    () => initialTab ?? new URLSearchParams(window.location.search).get('tab') ?? tabs[0]?.key ?? '',
  );
  const activeTab = tabs.some((t) => t.key === selected) ? selected : (tabs[0]?.key ?? '');

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 w-full space-y-6 duration-300">
      <PageHeader title="Settings" subtitle={subtitle ?? 'Manage your account and preferences.'} />
      {/* The single app tabs component (shadcn-based), underline variant. */}
      <PhaseSubTabs
        variant="underline"
        active={activeTab}
        tabs={tabs.map((t) => ({ key: t.key, label: t.label }))}
        onChange={setSelected}
      />
      <div className="pt-[4px]">{tabs.find((t) => t.key === activeTab)?.content}</div>
    </div>
  );
}
